module.exports = __webpack_public_path__ + "media/images/emoticons/mobilephone-4ae39d496cb745eb286501cb13ccb67d.gif";